<template>
	<fieldset class="declaration-fieldset">
		<legend>Declaration</legend>
		<div class="agreement-input">
			<input type="checkbox" :checked="value" id="isAcceptedEnwokeAgreement" @change="onChange" />
			I confirm that I am the rightful owner of this {{ contentName }} or that I have the permission of the
			{{ contentName }}
			owner and that the listing meets the
			<a href="https://enwoke.com/terms" target="_blank" rel="noopener noreferrer">ENWOKE terms & conditions</a>
		</div>
		<div class="text-right">
			<div class="clickable delete-link" @click="onClickDelete">Delete {{ contentName }}</div>
		</div>

		<v-dialog v-model="openDeleteDialog" width="500">
			<v-card>
				<v-card-title class="headline grey lighten-2" primary-title>
					Delete Content
				</v-card-title>

				<v-card-text>
					<h5 style="margin: 1rem 0;">Are you sure for delete {{ contentName }}?</h5>
				</v-card-text>

				<v-divider></v-divider>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="onAgreeDelete">
						Yes
					</v-btn>
					<v-btn color="red" text @click="openDeleteDialog = false">
						No
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</fieldset>
</template>

<script>
export default {
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		contentName: {
			type: String,
			default: 'experience',
		},
	},
	data() {
		return {
			openDeleteDialog: false,
		};
	},
	mounted() {
		this.checked = this.value;
	},
	methods: {
		onChange(ev) {
			this.$emit('input', ev.target.checked);
		},
		onClickDelete() {
			this.openDeleteDialog = true;
		},
		onAgreeDelete() {
			this.$emit('delete');
		},
	},
};
</script>

<style lang="scss">
.declaration-fieldset {
	.agreement-input input {
		margin: 0 10px;
		width: 20px;
		height: 20px;
	}

	.delete-link {
		text-transform: uppercase;
		text-decoration: underline;
		font-style: italic;
		font-size: 0.9rem;
		letter-spacing: 1.25px;
	}
}
</style>
